import { defineComponent as _defineComponent } from 'vue'
import Settings from "@/modules/Clients/pages/Settings.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'Settings',
  setup(__props) {


return { __sfc: true,Settings }
}

})